"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketCloseOptions = void 0;
/**
 * ws 关闭的原因
 */
exports.WebSocketCloseOptions = {
    /**
     * 重连关闭
     */
    reconnect: { code: 1000, reason: 'close websocket when reconnecting' },
    /**
     * 主动关闭
     */
    normalClosure: { code: 1000, reason: 'normal closure' },
    /**
     * 强制关闭
     */
    forceClosure: { code: 1000, reason: 'force closure' },
    /**
     * 切换到后台，被微信杀掉，需要重连连接
     */
    interrupted: { code: 1000, reason: 'interrupted' },
    /**
     * 服务端拒绝连接
     */
    streamEndEncountered: { code: 1000, reason: 'stream end encountered' },
    /**
     * 丢失心跳
     * @deprecated
     */
    lostHeartbeat: { code: 1000, reason: 'lost heartbeat' },
};
//# sourceMappingURL=WebSocketCloseOptions.js.map